<script lang="ts">
  import FailedAttachmentDisclaimer from './partials/FailedAttachmentDisclaimer.svelte';
  import UnSupportedAttachmentDisclaimer from './partials/UnSupportedAttachmentDisclaimer.svelte';
  import type { LicenseVerificationAttachment } from '$provider/models/license/LicenseVerificationAttachment';

  interface Props {
    attachment: LicenseVerificationAttachment;
    noAction?: boolean;
    onevent?: (payload: { type: 'click-attachment'; data: LicenseVerificationAttachment }) => void;
  }

  let { attachment, noAction = false, onevent }: Props = $props();

  let hrefUrl = $derived(attachment?.isExternalUrl ? attachment.source : '/');
  let target = $derived(attachment?.isExternalUrl ? '_blank' : '');

  const onClickAnchor = (): void => {
    if (attachment?.isExternalUrl) {
      window.open(attachment.source, '_blank');
      return;
    }

    if (attachment.isUnsupportedFileType) return;

    onevent?.({ type: 'click-attachment', data: attachment });
  };
</script>

<div class="license-attachment-list-type">
  <div class="license-attachment">
    <div data-cy="attachment-header" class="header">
      <div class="title">{attachment?.label}</div>
    </div>

    {#if !noAction || attachment?.isExternalUrl}
      <div class="attachment-link">
        <a
          class="link"
          href={hrefUrl}
          {target}
          data-cy={`attachment`}
          onclick={(e) => { e.preventDefault(); onClickAnchor(); }}
        >
          <span class="text">{attachment?.fileName}</span>
        </a>
      </div>
    {:else}
      <span class="text">{attachment?.fileName}</span>
    {/if}
  </div>
  {#if attachment?.isUnsupportedFileType}
    <UnSupportedAttachmentDisclaimer />
  {/if}
  {#if attachment?.isFailed}
    <FailedAttachmentDisclaimer {noAction} />
  {/if}
</div>

<style>
  .license-attachment-list-type {
    word-break: break-word;
  }
  .license-attachment-list-type .license-attachment {
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
  }
  .header .title {
    width: 150px;
    flex-shrink: 0;
    margin: 0px 16px 10px 0px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }
  .attachment-link .link {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: var(--blue);
    text-decoration: none;
  }
</style>
